import { endpoints } from "src/utils";
import { createListHook } from "src/actions/utils/create-action";


export const useGetMyInStoreReportCategories = createListHook(
    endpoints.me.inStoreReportsCategories.list,
);
